// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#feature-detecting_localstorage
export const isLocalStorageAvailable = () => {
  try {
    const storage = window.localStorage;
    const key = '__local_storage_test__';
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

const getOwnStorage = (): Storage => {
  const store: { [key: string]: string } = {};

  return {
    setItem: (key, value) => {
      store[key] = value;
    },
    getItem: (key) => {
      return key in store ? store[key] : null;
    },
    removeItem: (key) => {
      delete store[key];
    },
    clear: () => {
      Object.keys(store).forEach((key) => {
        delete store[key];
      });
    },
    key: (index) => {
      const keys = Object.keys(store);
      return keys[index] || null;
    },
    get length() {
      return Object.keys(store).length;
    },
  };
};

export const storage = isLocalStorageAvailable() ? window.localStorage : getOwnStorage();
